import { render, staticRenderFns } from "./EditWorkplaceModal.vue?vue&type=template&id=03db301e&"
import script from "./EditWorkplaceModal.vue?vue&type=script&lang=js&"
export * from "./EditWorkplaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports